import { Inject, Injectable } from '@angular/core'
import { RootState, setCurrentUser } from '@helios/state-management'
import { Store } from '@ngrx/store'
import {
  getTestAutomationAccessToken,
  getTestAutomationUser,
  isTestAutomationAuth,
} from './testautomation-auth'
import { DOCUMENT } from '@angular/common'
import { ConsoleSidenav, loadCwConsoleSidenav } from './console-sidenav'

@Injectable()
export class AuthTokenService {
  private _testAutomationAccessToken?: string
  private readonly sidenav$: Promise<ConsoleSidenav>

  constructor(
    private readonly store: Store<RootState>,
    @Inject(DOCUMENT) private readonly _document: Document,
  ) {
    this.sidenav$ = loadCwConsoleSidenav(this._document)
    if (isTestAutomationAuth()) this.initializeTestUser()
    else this.initializeRealUser()
  }

  async getToken(ignoreCache = false): Promise<string> {
    if (this._testAutomationAccessToken)
      return Promise.resolve(this._testAutomationAccessToken)

    // According to docs, this will use a cached copy until it is nearly expired, then renew it via API call
    // link: https://auth0.github.io/auth0-angular/classes/auth_service.AuthService.html#getAccessTokenSilently
    // When the entire login session is expired, this will send you to the configured logout page (essentially the same as clicking 'log out')
    // link: https://github.com/auth0/auth0-spa-js/blob/01e97e011eada8eff7f763aba89ca538173aa6b1/src/Auth0Client.ts#L920
    return (await this.sidenav$).getAccessTokenSilentlyOrLogout({
      ignoreCache,
    })
  }

  private async initializeRealUser() {
    this.store.dispatch(setCurrentUser({ user: (await this.sidenav$).user }))
  }

  /** @internal for test **/
  initializeTestUser() {
    this._testAutomationAccessToken = getTestAutomationAccessToken()
    if (!this._testAutomationAccessToken)
      throw new Error('expected testauto token') //shouldn't happen, we just checked for the existence of the token

    const user = getTestAutomationUser(this._testAutomationAccessToken)
    //yeah, sorry.  App Initializers run before the store is ready.  At some point we should figure out how to untangle initialization
    setTimeout(() => this.store.dispatch(setCurrentUser({ user })), 10)
  }
}
